import React from "react";
import { Row, Col, Form, Input } from "antd";
import {
  SectionHeading,
  DataHeading,
  GhostButtonComponent,
  SliderMainHeader
} from "../../../../CommonComponents/commonStyles";
import { ContactUs  } from "../../styles";
import { UserIdForm, HitASnag, Snag , SuccessImg} from "./styles";
import { HorizontalDivider } from "../../styles";
import tick from "../../../../assets/icons/small-circle-tick.svg";
import {
  ContentProvider,
  ContentMessage,
  Types
} from "../../../../CommonComponents/ContentMessages";
import PropTypes from 'prop-types';
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";

export default function UpdateEmailIDSuccess(props) {
  return (
    <div data-test="mfaEmailSuccess">
      <ContentProvider types={[Types.GET_CONFIRMATION_MESSAGE]} pages={["Email Updated"]}>
        <SectionHeading>
          <SliderMainHeader>
            <ContentMessage type={[Types.GET_CONFIRMATION_MESSAGE]} page="Email Updated" property="field_page_title" defaultMessage="Email Updated" />
          </SliderMainHeader>  
        </SectionHeading>   
        <Row>
          <Col lg={16} md={13}>
            <UserIdForm>
                <SuccessImg src={tick} alt="tick"/>
              <DataHeading className="mb-50">
              <ContentMessage type={[Types.GET_CONFIRMATION_MESSAGE]} html={true} page="Email Updated" property="field_success_message" defaultMessage="<p>You have successfully updated your email.</p>" />
              </DataHeading>
              <GeneralButton
                text="DONE"
                type="functional"
                disabled={false}
                id="btnDone"
                width="150px"
                maxWidth="990px"
                mobWidth="100%"
                onClick={props.closeDrawer}
                inverted={true}
              />
            </UserIdForm>
          </Col>
        </Row>
      </ContentProvider>
      <div className="mt-50">
      <HorizontalDivider />
      </div>
      <HitASnag className="mt-50" style={Snag}>                                
          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_8_title" defaultMessage="Hit a Snag?" />
      </HitASnag>
      <ContactUs>
        <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_type_8_description" defaultMessage="<p>Contact us: <br><span class='updateUserIdSnagContent'>888-383-4483 </span>or <br> <span class='updateUserIdSnagContent'>https://www.vanguardcharitable.org/contact-us</span></p>" />
      </ContactUs>
    </div>
  );
}

UpdateEmailIDSuccess.propTypes = {
  mfaEmail: PropTypes.string.isRequired,
  newmfaEmail: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired
}